import { render, staticRenderFns } from "./AllotmentPerAccommodation.vue?vue&type=template&id=f6162374&scoped=true&"
import script from "./AllotmentPerAccommodation.vue?vue&type=script&lang=js&"
export * from "./AllotmentPerAccommodation.vue?vue&type=script&lang=js&"
import style0 from "./AllotmentPerAccommodation.vue?vue&type=style&index=0&id=f6162374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6162374",
  null
  
)

export default component.exports